import { isEventLoggingValid } from './eventTracker';

export const GAEvent = (
  email: string,
  event: string,
  parameter: { [key: string]: string },
) => {
  return isEventLoggingValid(email) && window.gtag
    ? window.gtag('event', event, parameter)
    : null;
};
